<template lang="pug">
div
  div.filter-type.is-flex
    .flex-1
      span.title-tag 
        span Filter 
        span.filter-extra-text by tags
        span : 
      .tag(
        v-for="o in types"
        :class="{'selected': o.selected, 'new': o.code == 'new'}"
        @click="selectTypeFilter(o)"
      ) {{ o.name }}
  template(v-if="!mini")
    #algorithm-tabs-super-container-minimap.tabs-super-container.tabs-minimap
      .box-arrow-left.minimap.actionable-left
        img.chevron(:src="'/img/icons/left-chevron-' + mode +  '.svg'", alt="Scroll right")
      .box-shadow-container.left.box-shadow-container-left.minimap.actionable-left(v-show="tabParams.minimap.showLeftShadow")
      .tabs-container.tabs-container-actionable#algorithm-tabs-container(
        :style="'max-width: ' + tabsContainerMaxWidth + 'px'"
        data-type="minimap"
      )
        .tabs
          ul
            li(
              v-for="o in orderedAlgorithms"
              :class="{'active': o.code === selectedAlgo.code}"
              @click="selectAlgorithm(o, null, 'main')"
            )
              a {{ o.name }}
      .box-shadow-container.right.box-shadow-container-right.minimap.actionable-right(v-show="tabParams.minimap.showRightShadow")
      .box-arrow-right.minimap.actionable-right
        img.chevron(:src="'/img/icons/right-chevron-' + mode +  '.svg'", alt="Scroll right")
  #algorithm-tabs-super-container.tabs-super-container(:class="{'mini': mini}")
    .box-arrow-left.main.actionable-left
      img.chevron(:src="'/img/icons/left-chevron-' + mode +  '.svg'", alt="Scroll right")
    .box-shadow-container.left.box-shadow-container-left.main.actionable-left(v-show="tabParams.main.showLeftShadow")

    .tabs-container.tabs-container-actionable#algorithm-tabs-container(
      :style="!mini ? 'max-width: ' + tabsContainerMaxWidth + 'px' : ''",
      data-type="main"
    )
      .tabs
        ul
          li(
            v-for="o in orderedAlgorithms"
            v-if="!mini"
            :class="{'active': o.code === selectedAlgo.code}"
            @click="selectAlgorithm(o, null, 'minimap')"
          )
            a
              .tab-content
                template(v-if="!mini")
                  .box
                    .up-text
                      span(:class="{'has-opacity': o.deactivated}") {{ o.name }}
                      .warning-tag.hint--right(
                        v-if="o.deactivated"
                        aria-label="This pool not longer accepts connections."
                      )
                        span.has-opacity Deprecated
                      .new-tag(
                        v-if="o.new"
                      ) New
                      .beta-tag(
                        v-if="o.beta"
                      ) Beta
                    .down-text(:class="{'has-opacity': o.deactivated}", v-if="!mini") 
                      span For 
                      b {{ o.miningVia }}
                    .box-content
                      .general-main-info-algo
                        //- .last-rewarded
                          span For 
                          b {{ o.miningVia }}
                        .last-rewarded
                          span Algorithm  
                          b {{ o.longName || o.name }} 
                        //- .last-rewarded(v-if="o.minimumVramRequirement")
                          span Minimum VRAM requirement:  
                          b {{ o.minimumVramRequirement }}
                        .last-rewarded
                          span Rewards every  
                          b.last-reward-time.FOURALGO
                            i.fa.fa-circle-o-notch.fa-spin(v-if="isLoadingRewardData")
                            b(v-else)
                              span {{ o.averageReward }}
                        .last-rewarded
                          span Last rewarded  
                          b.timeago.last-reward.FOURALGO(:class="{'animate': o.lastRewardChanged}")
                            i.fa.fa-circle-o-notch.fa-spin(v-if="isLoadingRewardData")
                            template(v-else)
                              b(v-if="o.lastReward > 0") {{ o.lastReward | fromNow }}
                              b(v-else) -
                        .last-rewarded
                          span Based on
                          .algo-image.hint--top(:aria-label="o.symbol")
                            img(:src="o.symbolLogo", :alt="o.symbol + ' logo'")
                          span mining
                          span.extra-comment-hint.hint--top.hint--large.is-hidden-mobile(:aria-label="o.extraComment", v-if="o.extraComment")
                            i.fa.fa-cubes
                          template(v-if="o.symbolDesc != coin")
                            span.extra-comment-hint.hint--top.hint--large.is-hidden-mobile(:aria-label="'We will automatically convert ' + o.symbolDesc + ' to ' + coin + ' on each reward and credit it to your address'")
                              i.fa.fa-info-circle
                          template(v-else)
                            span.extra-comment-hint.hint--top.hint--large.is-hidden-mobile(:aria-label="'We will automatically credit ' + coin + ' to your address'")
                              i.fa.fa-info-circle
                          //- .symbol-container
                            span {{ o.symbol }}
                        //- .last-rewarded
                          span Mining fee  
                          b 1%
                        //- .last-rewarded
                          #w_min_amount_container
                            template(v-if="isLoadingCoinData || chainsCoin.length === 1")
                              span Payouts from  
                              b.w_min_amount(v-if="isLoadingCoinData")
                                i.fa.fa-circle-o-notch.fa-spin
                              b(v-else) {{ chainsCoin[0].payment_threshold }} {{ coin }}

                            template(v-else)
                              div
                                span Supported payout networks: 
                                b(v-for="(o, index) in chainsCoin") 
                                  span {{ o.network }} ({{ o.token_standard }})
                                  span(v-if="index !== chainsCoin.length - 1") , 
                                span .
                              div(v-for="o in chainsCoin")
                                span Payouts from 
                                b {{ o.payment_threshold }} {{ coin }} 
                                span via the 
                                b {{ o.network }} 
                                span chain.
                              div
                                span Compatible payout networks can be switched at any time.

                        //- .extra-comment.last-rewarded(v-if="o.extraComment")
                          span(v-html="o.extraComment")

                        //- .high_risk(v-if="highRiskCoin")
                          span {{ coin }} is a  
                          b highly volatile asset
                          span , daily mining rewards may be inconsistent due to large price fluctuations.

                        //- div.button.is-text.hint--top.get-started-button(v-if="o.isInOurEasyMiningApp || o.showInWizard", @click="$router.push('/start')", aria-label="For beginners and experienced miners") 
                          b Get started

                        //- div.button.is-text.get-started-button(v-if="!o.isInOurEasyMiningApp && !o.showInWizard && o.type === 'ASIC'", @click="$router.push('/support?search=ASIC')") 
                          b Get started
                template(v-else)
                  .up-text
                    span(:class="{'has-opacity': o.deactivated}") {{ o.name }}
                    .warning-tag.hint--right(
                      v-if="o.deactivated"
                      aria-label="This pool not longer accepts connections."
                    )
                      span.has-opacity Deprecated
                    .new-tag(
                      v-if="o.new"
                    ) New
                    .beta-tag(
                      v-if="o.beta"
                    ) Beta
                  .down-text(:class="{'has-opacity': o.deactivated}", v-if="o.hasNoWorkers") No workers
                  .down-text(:class="{'has-opacity': o.deactivated}", v-if="o.workers.length > 0") 
                    span {{ o.workers.length }} 
                    span(v-if="o.workers.length === 1") worker
                    span(v-else) workers

          li(
            v-for="o in algorithmsFiltered"
            v-if="mini && !o.hasNoWorkers"
            :class="{'active': o.code === selectedAlgo.code}"
            @click="selectAlgorithm(o)"
          )
            a
              .tab-content
                .up-text
                  span(:class="{'has-opacity': o.deactivated}") {{ o.name }}
                  .warning-tag.hint--right(
                    v-if="o.deactivated"
                    aria-label="This pool not longer accepts connections."
                  )
                    span.has-opacity Deprecated
                  .new-tag(
                    v-if="o.new"
                  ) New
                  .beta-tag(
                    v-if="o.beta"
                  ) Beta
                .down-text(:class="{'has-opacity': o.deactivated}", v-if="!mini") {{ o.type }}
                template(v-else)
                  .down-text(:class="{'has-opacity': o.deactivated}", v-if="o.hasNoWorkers") No workers
                  .down-text(:class="{'has-opacity': o.deactivated}", v-if="o.workers.length > 0") 
                    span {{ o.workers.length }} 
                    span(v-if="o.workers.length === 1") worker
                    span(v-else) workers

          li(
            v-for="o in algorithmsFiltered"
            v-if="mini && o.hasNoWorkers"
            :class="{'active': o.code === selectedAlgo.code}"
            @click="selectAlgorithm(o)"
          )
            a
              .tab-content
                .up-text
                  span(:class="{'has-opacity': o.deactivated}") {{ o.name }}
                  .warning-tag.hint--right(
                    v-if="o.deactivated"
                    aria-label="This pool not longer accepts connections."
                  ) 
                    span.has-opacity Deprecated
                  .new-tag(
                    v-if="o.new"
                  ) New
                  .beta-tag(
                    v-if="o.beta"
                  ) Beta
                .down-text(:class="{'has-opacity': o.deactivated}", v-if="!mini") {{ o.type }}
                template(v-else)
                  .down-text(:class="{'has-opacity': o.deactivated}", v-if="o.hasNoWorkers") No workers
                  .down-text(:class="{'has-opacity': o.deactivated}", v-if="o.workers.length > 0") 
                    span {{ o.workers.length }} 
                    span(v-if="o.workers.length === 1") worker
                    span(v-else) workers

    .box-shadow-container.right.box-shadow-container-right.main.actionable-right(v-show="tabParams.main.showRightShadow")
    .box-arrow-right.main.actionable-right
      img.chevron(:src="'/img/icons/right-chevron-' + mode +  '.svg'", alt="Scroll right")
</template>

<script>
import { apiGet } from '../util/general'
export default {
  name: 'c_start_algorithm_tab',
  props: ['selectedAlgorithm', 'mini', 'localAlgorithms'],
  data() {
    return {
      isLoadingRewardData: true,
      isLoadingCoinData: true,
      listOfAlgorithms: [],
      tabParams: {
        main: {
          showLeftShadow: false,
          showRightShadow: false,
          tabsContainerMaxWidth: 0,
          horizontalScroll: false,
          startX: 0,
          scrollLeft: 0,
          isHoveringLeft: false,
          isHoveringRight: false
        },
        minimap: {
          showLeftShadow: false,
          showRightShadow: false,
          tabsContainerMaxWidth: 0,
          horizontalScroll: false,
          startX: 0,
          scrollLeft: 0,
          isHoveringLeft: false,
          isHoveringRight: false
        }
      },
      showLeftShadow: false,
      showRightShadow: false,
      tabsContainerMaxWidth: 0,
      isDown: false,
      isOver: false,
      startX: 0,
      scrollLeft: 0,
      horizontalScroll: false,
      isHoveringLeft: false,
      isHoveringRight: false,
      lateralPadding: 1 * 16 * 2, // 32
      scrollMovement: 10,
      types: [
        {
          code: 'new',
          name: 'New',
          minimumRequirement: null,
          selected: false
        },
        {
          code: 'asic',
          name: 'ASIC',
          minimumRequirement: null,
          selected: false
        },
        {
          code: 'gpu',
          minimumRequirement: '3GB',
          name: 'GPU > 3GB',
          selected: false
        },
        {
          code: 'gpu',
          minimumRequirement: '4GB',
          name: 'GPU > 4GB',
          selected: false
        },
        {
          code: 'gpu',
          minimumRequirement: '6GB',
          name: 'GPU > 6GB',
          selected: false
        },
        {
          code: 'cpu',
          name: 'CPU',
          minimumRequirement: null,
          selected: false
        },
        {
          code: 'kasforks',
          name: 'Kaspa & forks',
          minimumRequirement: null,
          selected: false
        }
      ],
      lastAlgorithmsSelected: []
    }
  },
  computed: {
    coin() {
      return this.$store.getters.coin
    },
    algos() {
      return this.$store.getters.algos
    },
    selectedAlgo() {
      let vm = this
      if (typeof vm.selectedAlgorithm === 'string') {
        return vm.algos.find(element => element.code === vm.selectedAlgorithm)
      } else {
        return vm.selectedAlgorithm
      }
    },
    algorithms() {
      let vm = this
      let listOfAlgorithms = vm.localAlgorithms && vm.localAlgorithms.length > 0 ? vm.localAlgorithms : vm.listOfAlgorithms;
      return listOfAlgorithms;
    },
    algorithmsFiltered() {
      let vm = this
      let filtered = []
      let allUnSelected = true
      let i = 0
      let j = 0

      let filteredAlgorithmCodes = []
      for (i = 0; i < vm.algorithms.length; i++) {
        for (j = 0; j < vm.types.length; j++) {
          if (vm.algorithms[i].tags && vm.algorithms[i].tags.includes(vm.types[j].code) && vm.types[j].selected) {
            allUnSelected = false
            if (filteredAlgorithmCodes.indexOf(vm.algorithms[i].code) === -1) {
              filteredAlgorithmCodes.push(vm.algorithms[i].code)
              filtered.push(vm.algorithms[i])
            }
          }
          if (vm.algorithms[i].typeCode === vm.types[j].code && vm.algorithms[i].minimumVramRequirement === vm.types[j].minimumRequirement && vm.types[j].selected) {
            allUnSelected = false
            if (filteredAlgorithmCodes.indexOf(vm.algorithms[i].code) === -1) {
              filteredAlgorithmCodes.push(vm.algorithms[i].code)
              filtered.push(vm.algorithms[i])
            }
          } else {
            if (vm.algorithms[i].additionalTypes && vm.algorithms[i].additionalTypes.includes(vm.types[j].code) && vm.types[j].selected) {
              allUnSelected = false
              if (filteredAlgorithmCodes.indexOf(vm.algorithms[i].code) === -1) {
                filteredAlgorithmCodes.push(vm.algorithms[i].code)
                filtered.push(vm.algorithms[i])
              }
            }
          }
        }
      }
      if (allUnSelected) {
        return vm.algorithms
      }

      return filtered
    },
    orderedAlgorithms() {
      let vm = this
      // let ordered = [ ...vm.algorithmsFiltered ];

      let ordered = []
      let i = 0
      let j = 0

      for (i = 0; i < vm.lastAlgorithmsSelected.length; i++) {
        for (j = 0; j < vm.algorithmsFiltered.length; j++) {
          if (vm.lastAlgorithmsSelected[i] === vm.algorithmsFiltered[j].code && !vm.algorithmsFiltered[j].deactivated) {
            ordered.push(vm.algorithmsFiltered[j])
          }
        }
      }

      ordered = ordered.reverse();

      for (i = 0; i < vm.algorithmsFiltered.length; i++) {
        let foundInOrdered = false
        for (j = 0; j < ordered.length; j++) {
          if (vm.algorithmsFiltered[i].code === ordered[j].code) {
            foundInOrdered = true
          }
        }

        if (!foundInOrdered) {
          ordered.push(vm.algorithmsFiltered[i])
        }
      }
      return ordered;
    },
    mode() {
      return this.$store.getters.mode
    }
  },
  async created() {
    let vm = this
    // initialize list of algorithms
    let listOfAlgorithms = []

    for (let i = 0; i < vm.algos.length; i++) {
      let obj = {
        code: vm.algos[i].code,
        name: vm.algos[i].name,
        longName: vm.algos[i].longName,
        type: vm.algos[i].type,
        symbol: vm.algos[i].symbol,
        symbolDesc: vm.algos[i].symbolMerged || vm.algos[i].symbol,
        symbolLogo: vm.algos[i].symbolLogo,
        extraComment: vm.algos[i].extraComment,
        typeCode: vm.algos[i].typeCode,
        deactivated: vm.algos[i].deactivated,
        additionalTypes: vm.algos[i].additionalTypes,
        additionalTypesDescription: vm.algos[i].additionalTypesDescription,
        miningVia: vm.algos[i].miningVia,
        minimumVramRequirement: vm.algos[i].minimumVramRequirement,
        unitOfMeasurement: vm.algos[i].unitOfMeasurement,
        new: vm.algos[i].new,
        beta: vm.algos[i].beta,
        tags: vm.algos[i].tags,
        globalServer: JSON.parse(JSON.stringify(vm.algos[i].globalServer)),
        alternativeServers: JSON.parse(JSON.stringify(vm.algos[i].alternativeServers)),
        guides: JSON.parse(JSON.stringify(vm.algos[i].guides)),
        lastReward: '',
        lastRewardChanged: false,
        averageReward: '',
        warningMessage: vm.algos[i].warningMessage,
        warningDotMessage: vm.algos[i].warningDotMessage
      }

      listOfAlgorithms.push(obj)
    }

    vm.listOfAlgorithms = listOfAlgorithms

    vm.lastAlgorithmsSelected = [...vm.$store.getters.lastAlgorithms]
  },
  mounted() {
    let vm = this
    vm.fetchAlgorithmRewardsData();
    // let tabsContainer = document.getElementById('algorithm-tabs-container')
    let tabsContainers = document.querySelectorAll('.tabs-container-actionable')
    for (let tabsContainer of tabsContainers) {
      let type = tabsContainer.getAttribute('data-type')
      tabsContainer.addEventListener('scroll', vm.reprintShadowScroll)

      let actionablesLeft = document.querySelectorAll('.actionable-left.' + type)
      let actionablesRight = document.querySelectorAll('.actionable-right.' + type)

      for (let item of actionablesLeft) {
        item.addEventListener('click', (e) => {
          vm.tabParams[type].isHoveringRight = false
          vm.tabParams[type].isHoveringLeft = true
          // Calculate current width in viewport to skip a whole "page"
          let itemsInContainer = tabsContainer.querySelectorAll('.tabs li');
          let currentScrollPos = tabsContainer.scrollLeft;
          let newPos = (currentScrollPos - tabsContainer.offsetWidth);
          let offsetPos = 0;

          for (let itemInContainer of [ ...itemsInContainer ].reverse()) {
            if (itemInContainer.offsetLeft < newPos) {
              offsetPos = newPos - itemInContainer.offsetLeft + 25
              break;
            }
          }

          tabsContainer.scrollTo({
            top: 0,
            left: newPos - offsetPos,
            behavior: 'smooth'
          })
          vm.tabParams[type].isHoveringLeft = false
        });
        item.addEventListener('mouseover', () => {
          vm.isOver = true;
        });
        item.addEventListener('mouseleave', () => {
          vm.isOver = false;
        });
      }

      for (let item of actionablesRight) {
        item.addEventListener('click', (e) => {
          vm.tabParams[type].isHoveringLeft = false
          vm.tabParams[type].isHoveringRight = true
          // Calculate current width in viewport to skip a whole "page"
          let itemsInContainer = tabsContainer.querySelectorAll('.tabs li');
          let currentScrollPos = tabsContainer.scrollLeft;
          let newPos = (currentScrollPos + tabsContainer.offsetWidth);
          let offsetPos = 0;

          for (let itemInContainer of [...itemsInContainer]) {
            if (itemInContainer.offsetLeft > newPos) {
              offsetPos = newPos - itemInContainer.offsetLeft + 25
              break;
            }
          }

          tabsContainer.scrollTo({
            top: 0,
            left: newPos - offsetPos,
            behavior: 'smooth'
          })
          vm.tabParams[type].isHoveringRight = false
        });
        item.addEventListener('mouseover', () => {
          vm.isOver = true;
        });
        item.addEventListener('mouseleave', () => {
          vm.isOver = false;
        });
      }

      tabsContainer.addEventListener('mouseover', () => {
        vm.isOver = true;
      });

      tabsContainer.addEventListener('mousedown', (e) => {
        vm.lastTimeDown = +new Date();
        vm.isDown = true;
        vm.startX = e.pageX - tabsContainer.offsetLeft;
        vm.scrollLeft = tabsContainer.scrollLeft;
      });
      tabsContainer.addEventListener('mouseleave', () => {
        // setTimeout(function () {
        vm.isDown = false;
        vm.isOver = false;
        // }, 1)
      });
      tabsContainer.addEventListener('mouseup', () => {
        // setTimeout(function () {
        let itemsInContainer = tabsContainer.querySelectorAll('.tabs li');
        for (let itemInContainer of [...itemsInContainer]) {
          itemInContainer.style.pointerEvents = null;
        }
        vm.isDown = false;
        // }, 1)
      });
      tabsContainer.addEventListener('mousemove', (e) => {
        if (vm.lastTimeDown && vm.lastTimeDown > +new Date() - 100) return
        if (!vm.isDown) return;
        e.preventDefault();
        let itemsInContainer = tabsContainer.querySelectorAll('.tabs li');
        for (let itemInContainer of [...itemsInContainer]) {
          itemInContainer.style.pointerEvents = 'none';
        }
        vm.tabParams[type].isHoveringLeft = false
        vm.tabParams[type].isHoveringRight = false
        const x = e.pageX - tabsContainer.offsetLeft;
        const walk = (x - vm.startX) * 1; // scroll-normal
        tabsContainer.scrollLeft = vm.scrollLeft - walk;
      });
    }

    window.addEventListener('resize', vm.reprintShadowScroll);
    // Excecute after mounted
    setTimeout(function () {
      vm.reprintShadowScroll()
    }, 100)

    // setTimeout(function () {
    //   if (vm.selectedAlgo &&  vm.selectedAlgo.code) {
    //     vm.selectAlgorithm(vm.selectedAlgo)
    //   }
    // }, 100)
  },
  unmounted() {
    let vm = this
    // let tabsContainer = document.getElementById('algorithm-tabs-container')
    let tabsContainers = document.querySelectorAll('.tabs-container-actionable')
    for (let tabsContainer of tabsContainers) {
      tabsContainer.removeEventListener('scroll', vm.reprintShadowScroll)
    }
    window.removeEventListener('resize', vm.reprintShadowScroll);
  },
  beforeDestroy() {
    let vm = this
    window.removeEventListener('resize', vm.reprintShadowScroll);
  },
  sockets: {
    connect() {
      console.log('Global socket connected!')
    },
    stats_autolykos_last_reward(data) {
      let vm = this
      vm.setLastReward('autolykos', data)
    },
    stats_etchash_last_reward(data) {
      let vm = this
      vm.setLastReward('etchash', data)
    },
    stats_x16rv2_last_reward(data) {
      let vm = this
      vm.setLastReward('kawpow', data)
    },
    stats_ethash_last_reward(data) {
      let vm = this
      vm.setLastReward('ethash', data)
    },
    stats_beamhash_last_reward(data) {
      let vm = this
      vm.setLastReward('beamhash', data)
    },
    stats_zelhash_last_reward(data) {
      let vm = this
      vm.setLastReward('zelhash', data)
    },
    stats_randomx_last_reward(data) {
      let vm = this
      vm.setLastReward('randomx', data)
    },
    stats_scrypt_last_reward(data) {
      let vm = this
      vm.setLastReward('scrypt', data)
    },
    stats_sha256_last_reward(data) {
      let vm = this
      vm.setLastReward('sha256', data)
    },
    stats_equihash_last_reward(data) {
      let vm = this
      vm.setLastReward('equihash', data)
    },
    stats_kheavyhash_last_reward(data) {
      let vm = this
      vm.setLastReward('kheavyhash', data)
    },
    stats_blake3_last_reward(data) {
      let vm = this
      vm.setLastReward('blake3', data)
    },
    stats_fishhash_last_reward(data) {
      let vm = this
      vm.setLastReward('fishhash', data)
    },
    stats_octopus_last_reward(data) {
      let vm = this
      vm.setLastReward('octopus', data)
    },
    stats_nexapow_last_reward(data) {
      let vm = this
      vm.setLastReward('nexapow', data)
    },
    stats_ghostrider_last_reward(data) {
      let vm = this
      vm.setLastReward('ghostrider', data)
    },
    stats_xelishash_last_reward(data) {
      let vm = this
      vm.setLastReward('xelishash', data)
    },
    stats_karlsenhash_last_reward(data) {
      let vm = this
      vm.setLastReward('karlsenhash', data)
    }
  },
  methods: {
    fetchAlgorithmRewardsData() {
      var vm = this
      vm.isLoadingRewardData = true
      var url = '/v5/pool'
      var obj = {}
      apiGet(vm, url, obj, function (data) {
        for (var i = vm.listOfAlgorithms.length - 1; i >= 0; i--) {
          // if (vm.listOfAlgorithms[i].code === vm.selectedAlgorithm.code) {
          //   vm.selectedAlgorithm = vm.listOfAlgorithms[i]
          // }

          vm.listOfAlgorithms[i].lastReward = data.data.pools[vm.listOfAlgorithms[i].code] ? data.data.pools[vm.listOfAlgorithms[i].code].last_reward * 1000 : 0

          let averageReward = ''
          let averageText = 'minutes'
          if (data.data.pools[vm.listOfAlgorithms[i].code] && data.data.pools[vm.listOfAlgorithms[i].code].avg_reward_time) {
            if (data.data.pools[vm.listOfAlgorithms[i].code].avg_reward_time === 1) averageText = 'minute'
            averageReward = data.data.pools[vm.listOfAlgorithms[i].code].avg_reward_time + ' ' + averageText
          }

          if (averageReward) vm.listOfAlgorithms[i].averageReward = '~' + averageReward
          else vm.listOfAlgorithms[i].averageReward = '-'
        }
        setTimeout(function () {
          if (vm.selectedAlgo && vm.selectedAlgo.code) {
            vm.selectAlgorithm(vm.selectedAlgo)
          }
        }, 50)
      }, function (err) {
        console.error('Error:', err.message)
        vm.$store.dispatch('notifyError', err.message)
      }, function () {
        vm.isLoadingRewardData = false
      })
    },
    fetchCoinData() {
      var vm = this
      vm.isLoadingCoinData = true
      var url = '/v5/coin/' + vm.coin
      var obj = {}
      apiGet(vm, url, obj, function (data) {
        let chains = data.data.chains
        vm.chainsCoin = chains
        vm.highRiskCoin = data.data.high_risk
        vm.isMemoCoin = !!data.data.regex_memo
      }, function (err) {
        console.error('Error:', err.message)
        vm.$store.dispatch('notifyError', err.message)
      }, function () {
        vm.isLoadingCoinData = false
      })
    },
    selectAlgorithm(o, type = null, autoScrollType = false) {
      let vm = this
      if (!vm.isDown) vm.$emit('selected', o.code, type)
      if (!vm.mini) vm.$store.dispatch('addToAlgorithmList', o.code)
      if (!vm.mini) {
        setTimeout(function () {
          for (let autoScrollType of ['main', 'minimap']) {
            // Get the current position in large scroller
            let elMain = document.querySelectorAll('.tabs-container[data-type="' + autoScrollType + '"]')[0];
            let elActiveMain = document.querySelectorAll('.tabs-container[data-type="' + autoScrollType + '"] .tabs li.active')[0];

            let itemsInContainer = elMain.querySelectorAll('.tabs li');
            let actualItemsWidth = 0;
            for (let itemInContainer of [...itemsInContainer]) {
              actualItemsWidth += itemInContainer.scrollWidth;
            }

            let positionToSet = elActiveMain.offsetLeft - +(elMain.style.paddingLeft || '0').replace('px', '') - (elMain.offsetWidth / 2) + (elActiveMain.offsetWidth / 2);

            if (positionToSet < 0) {
              elMain.style.paddingLeft = (positionToSet * -1) + 'px'
            } else {
              elMain.style.paddingLeft = 0 + 'px'
            }

            let hasChangedWidth = false;
            if (positionToSet > actualItemsWidth - elMain.offsetWidth) {
              let widthToIncrease = positionToSet - (actualItemsWidth - elMain.offsetWidth);
              let currentPadding = elMain.style.paddingRight;
              if (widthToIncrease > 0 && widthToIncrease > +(currentPadding || '0').replace('px', '')) {
                elMain.style.paddingRight = widthToIncrease + 'px'
              }
            } else {
              hasChangedWidth = true
            }

            elMain.scrollTo({
              top: 0,
              left: positionToSet,
              behavior: 'smooth'
            });

            setTimeout(function () {
              if (hasChangedWidth) {
                elMain.style.paddingRight = 0 + 'px'
              }
            }, 300);
          }
        }, 50);
      }
    },
    reprintShadowScroll(e) {
      let vm = this
      // let tabsContainer = document.getElementById('algorithm-tabs-container')
      let tabsContainers = document.querySelectorAll('.tabs-container-actionable')
      vm.calculateMaxWidth()

      for (let tabsContainer of tabsContainers) {
        let type = tabsContainer.getAttribute('data-type')
        if (tabsContainer.clientWidth === 0) {
          setTimeout(function () {
            vm.reprintShadowScroll()
          }, 100)
        } else {
          if (tabsContainer.scrollWidth - tabsContainer.clientWidth === 0) {
            // There is no scroll
            vm.tabParams[type].showLeftShadow = false
            vm.tabParams[type].showRightShadow = false
            vm.tabParams[type].horizontalScroll = false
          } else {
            if (tabsContainer.scrollLeft !== 0) vm.tabParams[type].showLeftShadow = true
            else vm.tabParams[type].showLeftShadow = false

            if ((tabsContainer.scrollWidth - tabsContainer.clientWidth) - tabsContainer.scrollLeft < 1.1) vm.tabParams[type].showRightShadow = false
            else vm.tabParams[type].showRightShadow = true

            vm.tabParams[type].horizontalScroll = true
          }
        }
      }
      // if (tabsContainer.clientWidth === 0) {
      //   setTimeout(function () {
      //     vm.reprintShadowScroll()
      //   }, 100)
      // } else {
      //   if (tabsContainer.scrollWidth - tabsContainer.clientWidth === 0) {
      //     // There is no scroll
      //     vm.showLeftShadow = false
      //     vm.showRightShadow = false
      //     vm.horizontalScroll = false
      //   } else {
      //     if (tabsContainer.scrollLeft !== 0) vm.showLeftShadow = true
      //     else vm.showLeftShadow = false

      //     if ((tabsContainer.scrollWidth - tabsContainer.clientWidth) - tabsContainer.scrollLeft < 1.1) vm.showRightShadow = false
      //     else vm.showRightShadow = true

      //     vm.horizontalScroll = true
      //   }
      // }
    },
    calculateMaxWidth() {
      let vm = this
      if (document.documentElement.clientWidth < 768) {
        vm.tabsContainerMaxWidth = document.documentElement.clientWidth - vm.lateralPadding
      } else {
        let container = document.getElementById('algorithm-tabs-super-container')
        if (container) vm.tabsContainerMaxWidth = container.clientWidth
      }
    },
    reScroll() {
      let vm = this
      vm.calculateMaxWidth()
      vm.reprintShadowScroll()
    },
    doScroll(direction, amount, type) {
      let vm = this

      if (vm.tabParams[type].isHoveringLeft && vm.tabParams[type].isHoveringRight) {
        if (direction === 'left') vm.tabParams[type].isHoveringRight = false
        if (direction === 'right') vm.tabParams[type].isHoveringLeft = false
      }

      // let tabsContainer = document.getElementById('algorithm-tabs-container')
      let tabsContainers = document.querySelectorAll('.tabs-container-actionable[data-type="' + type + '"]')

      for (let tabsContainer of tabsContainers) {
        // let type = tabsContainer.getAttribute('data-type')

        if (vm.tabParams[type].isHoveringLeft && vm.tabParams[type].isHoveringRight) {
          if (direction === 'left') vm.tabParams[type].isHoveringRight = false
          if (direction === 'right') vm.tabParams[type].isHoveringLeft = false
        }

        if (tabsContainer.scrollLeft === 0) {
          vm.tabParams[type].isHoveringLeft = false
        } else if ((tabsContainer.scrollWidth - tabsContainer.clientWidth) - tabsContainer.scrollLeft < 1.1) {
          vm.tabParams[type].isHoveringRight = false
        }

        if (vm.tabParams[type].isHoveringLeft || vm.tabParams[type].isHoveringRight) {
          let leftScroll = tabsContainer.scrollLeft
          if (direction === 'left') leftScroll = tabsContainer.scrollLeft - amount
          else leftScroll = tabsContainer.scrollLeft + amount

          if (leftScroll < 0) leftScroll = 0

          tabsContainer.scrollTo({
            top: 0,
            left: leftScroll,
            behavior: 'smooth'
          })

          setTimeout(function () {
            if (vm.tabParams[type].isHoveringLeft && vm.tabParams[type].isHoveringRight) {
              if (direction === 'left') vm.tabParams[type].isHoveringRight = false
              if (direction === 'right') vm.tabParams[type].isHoveringLeft = false
            }
            if (vm.tabParams[type].isHoveringLeft && direction === 'left') vm.doScroll(direction, amount, type)
            if (vm.tabParams[type].isHoveringRight && direction === 'right') vm.doScroll(direction, amount, type)
          }, 50)
        }
      }

      // if (tabsContainer.scrollLeft === 0) {
      //   vm.isHoveringLeft = false
      // } else if ((tabsContainer.scrollWidth - tabsContainer.clientWidth) - tabsContainer.scrollLeft < 1.1) {
      //   vm.isHoveringRight = false
      // }

      // if (vm.isHoveringLeft || vm.isHoveringRight) {
      //   let leftScroll = tabsContainer.scrollLeft
      //   if (direction === 'left') leftScroll = tabsContainer.scrollLeft - amount
      //   else leftScroll = tabsContainer.scrollLeft + amount

      //   if (leftScroll < 0) leftScroll = 0

      //   tabsContainer.scrollTo({
      //     top: 0,
      //     left: leftScroll,
      //     behavior: 'smooth'
      //   })

      //   setTimeout(function () {
      //     if (vm.isHoveringLeft && vm.isHoveringRight) {
      //       if (direction === 'left') vm.isHoveringRight = false
      //       if (direction === 'right') vm.isHoveringLeft = false
      //     }
      //     if (vm.isHoveringLeft && direction === 'left') vm.doScroll(direction, amount)
      //     if (vm.isHoveringRight && direction === 'right') vm.doScroll(direction, amount)
      //   }, 50)
      // }
    },
    isTouchEvent() {
      return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    },
    selectTypeFilter(o) {
      let vm = this

      for (let j = 0; j < vm.types.length; j++) {
        if (vm.types[j].code === o.code) {
          o.selected = !o.selected
        } else vm.types[j].selected = false;
      }

      this.$nextTick(() => {
        if (vm.mini) {
          let foundWithWorkers = false
          for (let i = 0; i < vm.algorithmsFiltered.length; i++) {
            if (!vm.algorithmsFiltered[i].hasNoWorkers) {
              foundWithWorkers = true
              vm.selectAlgorithm(vm.algorithmsFiltered[i], 'filter')
              break
            }
          }
          if (!foundWithWorkers) vm.selectAlgorithm(vm.algorithmsFiltered[0], 'filter')
        } else {
          vm.selectAlgorithm(vm.orderedAlgorithms[0], 'filter')
        }
        vm.reScroll()
      })
    },
    setLastReward(algorithm, data) {
      let vm = this
      for (var i = 0; i < vm.listOfAlgorithms.length; i++) {
        if (vm.listOfAlgorithms[i].code === algorithm) {
          vm.listOfAlgorithms[i].lastReward = data * 1000
          vm.listOfAlgorithms[i].lastRewardChanged = true
          if (!vm.mini) {
            if (!vm.isOver && !vm.isTouchEvent()) {
              setTimeout(function () {
                vm.selectAlgorithm(vm.selectedAlgo)
              }, 100)
            }
          }
          setTimeout(function () {
            vm.listOfAlgorithms[i].lastRewardChanged = false
          }, 310)
          break
        }
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.mini
  .tabs ul li.active a .tab-content .up-text
    font-weight 700
  .tabs ul li a .tab-content .up-text
    font-size 16px
  .tabs ul li a
    padding: 0.5em 1em;

.new-tag
  display: inline-block;
  background: #b6ffb6;
  border-radius: 5px;
  margin-left: 4px;
  cursor: pointer;
  font-size: 9px;
  padding: 2px 5px 1px 5px;
  font-weight: 700;

.beta-tag
  display: inline-block;
  background: #fff2b6;
  border-radius: 5px;
  margin-left: 4px;
  cursor: pointer;
  font-size: 9px;
  padding: 2px 5px 1px 5px;
  font-weight: 700;
  
.warning-tag
  display: inline-block;
  background: #fff4c8;
  border-radius: 5px;
  margin-left: 4px;
  cursor: pointer;
  font-size: 9px;
  padding: 2px 5px 1px 5px;
  font-weight: 700;
  
.tabs-super-container
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  overflow-x: hidden;
  white-space: nowrap;
  font-size: .75rem;
  margin-bottom 1rem
  position relative
  border-bottom 0px
  padding-left 25px
  padding-right 25px
  &.mini
    max-width: calc(100vw - 28px);
  &.tabs-minimap
    margin-bottom 5px
    ul
      li
        margin: 0px 2.5px;
        padding 0px 5px
      li.active
        font-weight 700
        // text-decoration underline
    .tabs
      font-size 15px

.box-arrow-right, .box-arrow-left
  position: absolute;
  width: 20px;
  top: calc(50% - 10px);
  cursor pointer
  &.minimap 
    top: calc(50% - 7px);
    img
      width 14px
.box-arrow-right
  right: 0px;
.box-arrow-left
  left: 0px;
.box-shadow-container
  width 20px
  height 100%
  position absolute
  z-index: 10;
  display flex
  align-items center
  padding 5px
  cursor pointer
  -webkit-tap-highlight-color: transparent;
  &.left
    top 1px
    // left -2px
    left: 25px;
    box-shadow: inset 12px 0px 14px -13px #000;
  &.right
    top 1px
    // right -2px
    right: 25px;
    box-shadow: inset -12px 0px 14px -13px #000;

.extra-comment-hint
  font-size: 13px;
  margin-left 5px;
  vertical-align: middle;
.algo-image
  margin: 0px 5px;
  width: 15px;
  min-width: 15px;
  display: inline-block;
  vertical-align: middle;
.tabs-container
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  // max-height: 112px;
  width 100%
  overflow-x: auto;
  overflow-y: hidden;
  position relative
  scrollbar-width: none;
  transition padding-left .3s ease
  li.active a .tab-content .box
    box-shadow 0 2px 3px rgba(10,10,10,.5), 0 0 0 1px rgba(10,10,10,.5)

.hint--top.hint--large:after
  width 245px
  transform: translateX(-68%) translateY(-8px);

.hint--top.hint--large:before
  transform: translateY(-8px);

.hero .tabs ul
  border 0
.tabs
  overflow-x hidden
  border-bottom 0px
  margin-bottom 0px

  ul
    align-items: center;
    display: flex;
    flex-grow: 1;
    flex-shrink: 0;
    justify-content: flex-start;
    // border-bottom: 1px;
    // border-bottom-color: #dbdbdb;
    // border-bottom-style: solid;
    // border-bottom-width: 1px;
    align-items: flex-end;

    li
      display: block;
      a
        border: 1px solid transparent;
        color: #4a4a4a;
        display: flex;
        justify-content: center;
        margin-bottom: -1px;
        padding: 0.5em 0.25em;
        vertical-align: top;
      
        .tab-content
          text-align center
          padding 0px
          .box .box-content
            margin-top: 10px;
            padding-top: 10px;
            border-top: solid #ccc 1px;
            text-align: left;
          .up-text
            font-size 18px
            font-weight: 400;
            display flex
            align-items center
          .down-text
            font-weight 400
            font-size 11px
            text-align left
        
      &.disabled
        .tab-content
          opacity 0.5
      
      // &.active
      //   box-shadow 0px 1px #717171
      //   border-bottom-color: #717171;
      //   border-bottom-style: solid;
      //   border-bottom-width: 1px;

.filter-type
  text-align center
  margin-bottom: 5px;
  .title-tag
    font-size 0.8rem
    padding-top 4px
  .tag
    font-size 0.7rem
    cursor pointer
    margin-left 5px
    color: #717171
    background-color transparent
    border-color: #e5e5e5;
    border-style: solid;
    border-width: 1px;
    user-select: none;
    &.selected
      border-color: #717171;
      font-weight 400
    &.new.selected
      border-color: #609660;
    &.new
      border-color: #b0e7b0;
      color: #519251;
html.dark, body.dark

  .mini
    .tabs ul li a .tab-content 
        .up-text, .down-text
          color #fff
  .box-shadow-container
    &.left
      box-shadow: inset 16px 0px 13px -13px #565656;
    &.right
      box-shadow: inset -12px 0px 13px -13px #565656;
  .filter-type .tag.new
    border-color: #fff;
  .filter-type .tag.selected.new
    background-color: #b6ffb6;
    border-color: #b6ffb6;
  .tabs-container[data-type="minimap"]
    ul li,a
      color #fff
  .tabs-container
    ul
      li
        &.active
          box-shadow 0px 1px #fff
          border-bottom-color: #fff;
      li.active a .tab-content .box
        // box-shadow 0 2px 3px rgba(10,10,10,.5), 0 0 0 1px rgba(10,10,10,.5)
        box-shadow 0 2px 3px #ffffff, 0 0 0 1px #ffffff;
      li a .tab-content .box
        background: black;
        color: #fff;
        .tab-content
          color: #fff;
  .filter-type
    .title-tag
      color #fff
    .tag
      color #fff
      &.selected
        color #000
        background-color #fff
        border-color #fff
  .new-tag
    color #000

// @media (max-width: 1279px)
//   .tabs-container
//     max-width: calc(100vw - 400px);

@media (max-width: 1279px) and (min-width: 1088px)
  .tabs-container
    max-width: calc(960px - 50px);

@media (max-width: 429px)
  .filter-extra-text
    display none

@media (max-width: 550px)
  .tabs-container
    ul
      li
        padding-left: 3px;
        padding-right: 3px;
  .filter-type .tag
    margin-bottom:5px;
    font-size 14px
  .tabs-super-container.tabs-minimap ul li
    font-size 18px
  .tabs ul li a .tab-content .up-text
    font-size 20px
  .box-arrow-right, .box-arrow-left
    display none
  .tabs-super-container
    padding-left: 0
    padding-right: 0
  .box-shadow-container.left
    left -2px
  .box-shadow-container.right
    right -2px
  .tabs ul li
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

/* total width */
.tabs-container::-webkit-scrollbar {
    display none
}

img.chevron
  user-drag: none;  
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;

</style>



// WEBPACK FOOTER //
// c_tab_algorithm_select.vue?78cff56b